import React from 'react';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Typography } from '@hiiretail/synergy-ui';

import { ServiceCard, ServiceCardBody, ServiceCardHeader } from './ServiceTile.styles';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';

export type HiiService = {
  name: string;
  description: string;
  route: string;
  external: boolean;
  beta: boolean;
};

type ServiceTileProps = {
  service: HiiService;
  index: number;
};

type ServiceTileComponent = React.FC<ServiceTileProps>;

const BetaChip = styled(Typography)`
  background: #3d3465;
  color: white;
  border-radius: 4px;
  font-size: 12px;
  padding: 4px 8px;
  line-height: 16px;
`;

export const ServiceTile: ServiceTileComponent = ({ service, index }) => {
  const getTenantAlias = () => globalThis.location.hostname.split('.')[0];

  const handleServiceCardClick = (service: HiiService) => {
    if (service.external) {
      globalThis.open(service.route, '_blank')?.focus();
      return;
    }
    globalThis.location.href += service.route;
  };

  if (service.route === 'https://developer.hiiretail.com/' && getTenantAlias() !== 'extenda') {
    return null;
  }

  return (
    <ServiceCard
      container
      direction="column"
      justifyContent="space-between"
      alignItems="flex-start"
      flex="1 1 auto"
      role="button"
      tabIndex={index}
      onClick={() => handleServiceCardClick(service)}>
      <ServiceCardHeader container alignItems="flex-start" justifyContent="space-between">
        <Typography variant="header4">{service.name}</Typography>
        {service.external && (
          <Tooltip title="Open in new tab">
            <OpenInNewIcon />
          </Tooltip>
        )}

        {service.beta && <BetaChip>Beta</BetaChip>}
      </ServiceCardHeader>

      <ServiceCardBody container>
        <Typography variant="body2">{service.description}</Typography>
      </ServiceCardBody>
    </ServiceCard>
  );
};
